const localStorageService = {};

const createKey = (id) => {
  return "pf_yts_" + id + "_notification-closed";
};

localStorageService.add = (id, value) => {
  if (window.localStorage) {
    window.localStorage.setItem(createKey(id), value);
  }
};

localStorageService.get = (id) => {
  if (window.localStorage) {
    return window.localStorage.getItem(createKey(id));
  }
};

localStorageService.remove = (id) => {
  if (window.localStorage) {
    window.localStorage.removeItem(createKey(id));
  }
};

module.exports = localStorageService;

